// extracted by mini-css-extract-plugin
export default {"keyFactsTable":"Keyfacts_keyFactsTable__9Ph3L","headerWrapper":"Keyfacts_headerWrapper__zXxyp","contentWrapper":"Keyfacts_contentWrapper__xyO0Z"};